// Back-translation languages supported by the DeepSeek /translate endpoint.
// `code` values must match settings.DEEPSEEK_LANGUAGES on the server.
export const translationOptions = [
  { language: '中文 - 简体', code: 'zh-Hans' },
  { language: '中文 - 繁體', code: 'zh-Hant' },
  { language: 'Español', code: 'es' },
  { language: 'Deutsch', code: 'de' },
  { language: 'Français', code: 'fr' },
  { language: 'Italiano', code: 'it' },
  { language: 'Polski', code: 'pl' },
  { language: 'Português', code: 'pt' },
  { language: '日本語', code: 'ja' },
  { language: '한국어', code: 'ko' },
  { language: 'русский', code: 'ru' },
  { language: 'Українська', code: 'uk' },
];

export const codeToLanguage = translationOptions.reduce((acc, { language, code }) => {
  acc[code] = language;
  return acc;
}, {});

// When the interface language changes, default the back-translation to match it.
export const interfaceLanguageToTranslationCode = {
  'zh-Hans': 'zh-Hans',
  'zh-Hant': 'zh-Hant',
  ja: 'ja',
  fr: 'fr',
  uk: 'uk',
  de: 'de',
  ru: 'ru',
  pt: 'pt',
  es: 'es',
  en: null,
};

// Map a browser/interface locale (e.g. "es-ES", "zh-CN") to a supported code.
const localeToTranslationCode = (raw) => {
  if (!raw) return null;
  const lower = String(raw).toLowerCase();

  if (lower.startsWith('zh')) {
    if (lower.includes('hant') || lower.includes('tw') || lower.includes('hk') || lower.includes('mo')) {
      return 'zh-Hant';
    }
    return 'zh-Hans';
  }

  const base = lower.split('-')[0];
  const supported = ['es', 'de', 'fr', 'it', 'pl', 'pt', 'ja', 'ko', 'ru', 'uk'];
  return supported.indexOf(base) > -1 ? base : null;
};

const isEnglish = (raw) => {
  const lower = String(raw || '').toLowerCase();
  return lower === 'en' || lower.startsWith('en-');
};

// Guess a default back-translation language from the user's locale/interface
// settings. Returns null (feature off) when the user's preferred language is
// English or no supported language is found.
export const guessTranslationLanguage = (interfaceLanguage) => {
  const candidates = [];

  // An explicitly non-English interface language is a strong signal.
  if (interfaceLanguage && interfaceLanguage !== 'en') {
    candidates.push(interfaceLanguage);
  }

  if (typeof navigator !== 'undefined') {
    if (navigator.languages && navigator.languages.length) {
      candidates.push(...navigator.languages);
    } else if (navigator.language) {
      candidates.push(navigator.language);
    }
  }

  for (let i = 0; i < candidates.length; i++) {
    const candidate = candidates[i];
    // If the top preference is English, leave translation off.
    if (isEnglish(candidate)) {
      return null;
    }
    const code = localeToTranslationCode(candidate);
    if (code) {
      return code;
    }
  }

  return null;
};
